/**
 * switchWorkspaceProject — clears workspace-project state, invalidates
 * stale fetch cache entries, loads the new workspace project.
 *
 * NOTE: sdk.workspaceProject.getWorkspaceProject may not exist yet
 * (Phase 1.5 / Phase 8 addition). The absence is handled gracefully.
 */

const WORKSPACE_PROJECT_KEYS = new Set(['workspaceProject'])

/**
 * @param {object} state    - DOMQL root state
 * @param {object} sdk      - SDK instance
 * @param {object} queryClient - @symbo.ls/fetch queryClient
 * @param {string} newWPId  - target workspace project ID
 */
export const switchWorkspaceProject = async (state, sdk, queryClient, newWPId) => {
  for (const k of WORKSPACE_PROJECT_KEYS) state[k] = null

  // Workspace Project cache is mostly tickets/chats with WP id in params.
  // Mark all stale; refetch lazily.
  queryClient.invalidateQueries()

  state.workspaceProject = await sdk.workspaceProject?.getWorkspaceProject?.(newWPId) || null
  localStorage.setItem('activeWorkspaceProject', newWPId)
}
